var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"},on:{"after-leave":_vm.destoryElement}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"message-wrap",class:[{ success: _vm.type === 'success' },
    { warning: _vm.type === 'warning' },
    { error: _vm.type === 'error' },
    { info: _vm.type === 'info' },],style:({ top: _vm.top + 'px' })},[_c('span',{staticClass:"msg"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }